import { isDevelopment } from './utils/dev';
if (window.__fw_app__.tvSession) {
    const logger = document.createElement('div');
    logger.style.position = 'sticky';
    logger.style.bottom = '0';
    logger.style.left = '0';
    logger.style.width = '100%';
    logger.style.height = '100px';
    logger.style.backgroundColor = 'white';
    logger.style.borderTop = '4px solid black';
    logger.style.whiteSpace = 'pre-line';
    logger.style.overflowY = 'scroll';
    logger.style.color = 'black';
    logger.style.zIndex = '1000';
    logger.style.pointerEvents = 'none';
    logger.style.userSelect = 'none';
    document.body.appendChild(logger);
    document.addEventListener('wlaRemoteKeyEvent', (event) => {
        const { detail } = event;
        logger.textContent = `${logger.textContent}${Date.now()}: wlaRemoteKeyEvent: ${detail.key}\n`;
        logger.scrollTop = logger.scrollHeight;
        const activeElement = document.activeElement;
        if (!activeElement)
            return focusFirstElement();
        if (activeElement instanceof HTMLElement && !activeElement.dataset.tvFocusable) {
            return focusFirstElement();
        }
        if (detail.key === 'KEYCODE_DPAD_RIGHT') {
            focusNextFocusable();
        }
        if (detail.key === 'KEYCODE_DPAD_LEFT') {
            focusPreviousFocusable();
        }
        if (detail.key === 'KEYCODE_DPAD_UP') {
            const activeElement = document.activeElement;
            if (!activeElement)
                return;
            const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
            if (!(closestFocusContainer instanceof HTMLElement))
                return;
            if (closestFocusContainer.dataset.tvFocusContainerGrid) {
                focusPrevoiusGridFocusable();
            }
            else {
                focusPreviousContainer();
            }
        }
        if (detail.key === 'KEYCODE_DPAD_DOWN') {
            const activeElement = document.activeElement;
            if (!activeElement)
                return;
            const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
            if (!(closestFocusContainer instanceof HTMLElement))
                return;
            if (closestFocusContainer.dataset.tvFocusContainerGrid) {
                focusNextGridFocusable();
            }
            else {
                focusNextContainer();
            }
        }
        if (detail.key === 'KEYCODE_DPAD_CENTER') {
            const activeElement = document.activeElement;
            if (!(activeElement instanceof HTMLElement))
                return;
            activeElement.click();
        }
    });
    document.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' ||
            event.key === 'ArrowLeft' ||
            event.key === 'ArrowUp' ||
            event.key === 'ArrowDown') {
            logger.textContent = `${logger.textContent}${Date.now()}: keydown: ${event.key}\n`;
            logger.scrollTop = logger.scrollHeight;
            event.preventDefault();
        }
    });
    if (isDevelopment()) {
        document.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_RIGHT',
                    },
                }));
            }
            if (event.key === 'ArrowLeft') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_LEFT',
                    },
                }));
            }
            if (event.key === 'ArrowUp') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_UP',
                    },
                }));
            }
            if (event.key === 'ArrowDown') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_DOWN',
                    },
                }));
            }
            if (event.key === 'Enter') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_CENTER',
                    },
                }));
            }
        });
    }
    const getPreviousSibling = (elem, selector) => {
        let sibling = elem.previousElementSibling;
        if (!selector)
            return sibling;
        while (sibling) {
            if (sibling.matches(selector))
                return sibling;
            sibling = sibling.previousElementSibling;
        }
    };
    const getNextSibling = (elem, selector) => {
        let sibling = elem.nextElementSibling;
        if (!selector)
            return sibling;
        while (sibling) {
            if (sibling.matches(selector))
                return sibling;
            sibling = sibling.nextElementSibling;
        }
    };
    const focusPreviousFocusable = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        if (!(activeElement instanceof HTMLElement))
            return;
        const previousElement = getPreviousSibling(activeElement, '[data-tv-focusable]');
        if (previousElement && previousElement instanceof HTMLElement) {
            previousElement.focus();
        }
    };
    const focusNextFocusable = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        if (!(activeElement instanceof HTMLElement))
            return;
        const nextElement = getNextSibling(activeElement, '[data-tv-focusable]');
        if (nextElement && nextElement instanceof HTMLElement) {
            nextElement.focus();
        }
    };
    const focusPreviousContainer = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
        if (!closestFocusContainer)
            return;
        const allFocusContainers = document.querySelectorAll('[data-tv-focus-container]');
        const currentFocusContainerIndex = Array.from(allFocusContainers).indexOf(closestFocusContainer);
        if (currentFocusContainerIndex === 0)
            return;
        const previousFocusContainer = allFocusContainers[currentFocusContainerIndex - 1];
        if (previousFocusContainer) {
            previousFocusContainer.querySelector('[data-tv-focusable]')?.focus();
            previousFocusContainer.querySelector('[data-tv-focusable].active')?.focus();
        }
    };
    const focusNextContainer = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
        if (!closestFocusContainer)
            return;
        const allFocusContainers = document.querySelectorAll('[data-tv-focus-container]');
        const currentFocusContainerIndex = Array.from(allFocusContainers).indexOf(closestFocusContainer);
        if (currentFocusContainerIndex === allFocusContainers.length - 1)
            return;
        const nextFocusContainer = allFocusContainers[currentFocusContainerIndex + 1];
        if (nextFocusContainer) {
            nextFocusContainer.querySelector('[data-tv-focusable]')?.focus();
        }
    };
    const focusPrevoiusGridFocusable = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
        if (!(closestFocusContainer instanceof HTMLElement))
            return;
        const allFocusables = closestFocusContainer.querySelectorAll('[data-tv-focusable]');
        const currentFocusableIndex = Array.from(allFocusables).indexOf(activeElement);
        if (currentFocusableIndex < 3)
            return focusPreviousContainer();
        const newFocusElement = allFocusables[currentFocusableIndex - 3];
        if (newFocusElement instanceof HTMLElement) {
            newFocusElement.focus();
        }
    };
    const focusNextGridFocusable = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
        if (!(closestFocusContainer instanceof HTMLElement))
            return;
        const allFocusables = closestFocusContainer.querySelectorAll('[data-tv-focusable]');
        const currentFocusableIndex = Array.from(allFocusables).indexOf(activeElement);
        const newFocusElement = allFocusables[currentFocusableIndex + 3];
        if (newFocusElement instanceof HTMLElement) {
            newFocusElement.focus();
        }
    };
    const focusFirstElement = () => {
        document.querySelector('[data-tv-focusable]')?.focus();
        document.querySelector('.tv-header__tab.active')?.focus();
    };
    document.addEventListener('turbo:load', () => {
        focusFirstElement();
    });
}
